export default __webpack_public_path__ + "static/Litepaper - Korean-bdbd88be1507ac8b06339be231cc0a3e.pdf";